<template>
    <div class="row">
        <div class="col-md-12 mb-3">
            <el-form label-position="left" label-width="50px">
                <div class="row">
                    <div class="col-12 d-flex flex-column flex-md-row">
                        <div class="me-4 mb-2 mb-md-0">
                            Area: 
                            <el-radio-group v-model="area" size="small" name="area">
                                <el-radio-button :label="item5.value" v-for="(item5, index5) in options.area" :key="item5.value+'_'+index5" style="margin-left:0px;">{{item5.name}}</el-radio-button>
                            </el-radio-group>
                        </div>
                        <div class="me-3 mb-2 mb-md-0">
                            Tahun:
                            <el-select v-model="year" clearable filterable placeholder="Tahun" size="small" style="width:120px;">
                                <el-option v-for="item3 in options.years" :key="item3.value" :label="item3.name" :value="item3.value">
                                </el-option>
                            </el-select> 
                        </div>

                        <el-button type="primary" class="" size="small" :loading="loading.table" @click="applyFilter" style="width:120px;">Apply Filter</el-button>
                    </div>						
                </div>
            </el-form>
        </div>
    
        <div class="col-md-12">
            <div class="table-sales-tracking-container">
                <table class="table-sales-tracking">
                    <thead class="top-header-1">
                        <tr>
                            <th style="min-width: 400px; z-index:3;">Unit</th>
                            <th>Januari</th>
                            <th>Februari</th>
                            <th>Maret</th>
                            <th>April</th>
                            <th>Mei</th>
                            <th>Juni</th>
                            <th>Juli</th>
                            <th>Agustus</th>
                            <th>September</th>
                            <th>Oktober</th>
                            <th>November</th>
                            <th>Desember</th>
                            <th>Avg SPD YTD</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, idx) in paginatedData" :key="item.CostCenter +'-'+idx">
                            <td>{{ item.UnitName }}</td>

                            <td class="text-right">{{ formatNum(item.SpdJan, 2) }}</td>
                            <td class="text-right">{{ formatNum(item.SpdFeb, 2) }}</td>
                            <td class="text-right">{{ formatNum(item.SpdMar, 2) }}</td>
                            <td class="text-right">{{ formatNum(item.SpdApr, 2) }}</td>
                            <td class="text-right">{{ formatNum(item.SpdMay, 2) }}</td>
                            <td class="text-right">{{ formatNum(item.SpdJun, 2) }}</td>
                            <td class="text-right">{{ formatNum(item.SpdJul, 2) }}</td>
                            <td class="text-right">{{ formatNum(item.SpdAug, 2) }}</td>
                            <td class="text-right">{{ formatNum(item.SpdSep, 2) }}</td>
                            <td class="text-right">{{ formatNum(item.SpdOct, 2) }}</td>
                            <td class="text-right">{{ formatNum(item.SpdNov, 2) }}</td>
                            <td class="text-right">{{ formatNum(item.SpdDec, 2) }}</td>
                            <td :class="'text-right font-weight-bold'">{{ formatNum(item.SpdYtd, 2) }}</td> </tr>
                    </tbody>
                </table>
            </div>
            <div class="row">
                <div class="col-md-12 justify-content-end">
                    <!-- Pagination Controls -->
                    <nav aria-label="Page navigation" v-if="totalPages > 1">
                        <ul class="pagination">
                            <li class="page-item" :class="{ disabled: currentPage === 1 }">
                                <a class="page-link btn" @click.prevent="goToPage(1)">First</a>
                            </li>
                            <li class="page-item" :class="{ disabled: currentPage === 1 }">
                                <a class="page-link btn" @click.prevent="prevPage">Previous</a>
                            </li>

                            <!-- Tombol angka -->
                            <li
                            v-for="page in pagesToShow"
                            :key="page"
                            class="page-item page-item-button"
                            :class="{ active: currentPage === page }"
                            >
                                <a class="page-link btn" @click.prevent="goToPage(page)">{{ page }}</a>
                            </li>

                            <li class="page-item" :class="{ disabled: currentPage === totalPages }">
                                <a class="page-link btn" @click.prevent="nextPage">Next</a>
                            </li>
                            <li class="page-item" :class="{ disabled: currentPage === totalPages }">
                                <a class="page-link btn" @click.prevent="goToPage(totalPages)">Last</a>
                            </li>
                        </ul>
                    </nav>
                </div>
            </div>
            <Loader v-if="loading.table" />
        </div>
    </div>
</template>


<script>
import Fuel from '@/components/page/Fuel.js'
//import ReportParamSelect from '@/views/pages/ReportParamSelect.vue'
import ReportResultTable from '@/views/pages/ReportResultTable2.vue'
import { Rainbow, FuelColor, Config, Penanggalan, AxiosWithJar } from '@/utility.js'
import Loader from '@/components/loader/Loader2.vue'
import LineChart from '@/components/chart/LineChart.js'
import BarChart from '@/components/chart/BarChart.js'
import PieChart from '@/components/chart/Pie.js'

export default {
    extends:Fuel,
	components: {
        Loader,
        //BarChart,
        //PieChart,
    },
    props: ['tabIndex','tabName', 'tabLabel'],
    watch:{

    },
    mounted() {
        this.$emit('childrenRoute');
        this.getData();
    },
    data() {
		return {
            reportdata: {
                data: [],
            },
            monthBefore: this.getMonthName(Penanggalan().bulan-1),
            year: Penanggalan().tahun,
            month: Penanggalan().bulan,
            area: '',

            options : {
                area: [
                    { value: '', name: 'All'},
                    { value: '1', name: '1'},
                    { value: '2', name: '2'},
                    { value: '3', name: '3'},
                    { value: '4', name: '4'},
                    { value: '5', name: '5'},
                ],
                years: this.getLastYears(5),
            },

            loading: {
                table: false,
                chart: false,
                isSuccess: false,
            },    

            months: ['jan','feb'],
            currentPage: 1,
            perPage: 10,
        }
    },
    methods:{
        async getData() {
            //
			this.urlRequestParams = Config().apiURL
			this.urlRequestParams += '/v1/businesstracking/spdfuel?'

            this.urlRequestParams += '&year='+this.year
			this.urlRequestParams += '&month='+this.month
			this.urlRequestParams += '&area='+this.area
			
            this.loading.table = true;
			this.loading.isSuccess = false;
			AxiosWithJar().get(this.urlRequestParams)
				.then((response)=>{ 
					this.loading.isSuccess = true;
					this.reportdata = response.data;

				})
				.catch(error => {
					console.log(error)
					//this.errored = true
					//error.response.data
				})
				.finally(() => {
					this.loading.table = false;
				})
        },
        prevPage() {
            if (this.currentPage > 1) {
                this.currentPage--;
            }
        },
        nextPage() {
            if (this.currentPage < this.totalPages) {
                this.currentPage++;
            }
        },
        goToPage(page) {
            this.currentPage = page;
        },
        applyFilter() {
            this.getData();
        },
       
    },
    computed: {
        totalPages() {
            return Math.ceil(this.reportdata.data.length / this.perPage);
        },
        paginatedData() {
            const start = (this.currentPage - 1) * this.perPage;
            return this.reportdata.data.slice(start, start + this.perPage);
        },
        pagesToShow() {
            const pages = [];
            const totalPages = this.totalPages;

            // Logika untuk menampilkan 5 tombol angka
            const startPage = Math.max(1, this.currentPage - 2); // Minimal halaman 1
            const endPage = Math.min(totalPages, startPage + 4); // Maksimal 5 halaman

            // Jika startPage terlalu rendah, sesuaikan
            const adjustedStartPage = Math.max(1, endPage - 4);

            for (let i = adjustedStartPage; i <= endPage; i++) {
                pages.push(i);
            }

            return pages;
        },
    },
}
</script>

<style>
.pagination-controls {
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
}

.pagination {
  justify-content: center;
  margin-top: 10px;
}

.page-item {
  cursor: pointer;
}

.page-item-button {
  width: 55px;
  text-align: center;
}

.page-item.disabled .page-link {
  pointer-events: none;
  color: #6c757d; /* Bootstrap gray */
}

.page-item.active .page-link {
  background-color: #007bff;
  border-color: #007bff;
  color: white;
}
</style>